import Vue from 'vue';
import 'src/material/global/vendor/chart-js/Chart.min';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import rentalService from './../../../services/rental';
import analyticsService from '../../../services/analytics';
import Colorpicker from './../../../components/colorpicker/Colorpicker';
import mixin from './../../../mixins/mixin';
import accountService from '../../../services/account';

export default {
  data() {
    return {
      rentals: [],
      selectedRental: '',
      loading: true,
      disabled: false,
      noData: false,
      alreadyRendered: false,
      chartMarket: {},
      ctx: {},
      dateFillter: new Date(),
      marketDate: [moment().format('MMM DD, YYYY'), moment().add(30, 'days').format('MMM DD, YYYY')],
      language: localStorage.getItem('lang'),
      ownRentalUrl: {
        url: '',
        name: '',
        color: this.getRandomColor(),
        nbr_guests: this.defaultGuestCount,
        min_nights: this.defaultMinNight,
      },
      competitorsUrls: [],
      marketDateNotAfter: moment().add(90, 'days'),
      marketDateNotBefore: moment(),
      prices: {},
      pricesData: {
        own: [],
        competitors: [],
      },
      max: [],
      min: [],
      tableDates: [],
      shortcuts: [
        {
          text: this.$t('analytics.index.market_tab.start_date'),
          start: moment().format('MMM DD, YYYY'),
          end: moment().add(14, 'days').format('MMM DD, YYYY'),
        }, {
          text: this.$t('analytics.index.market_tab.end_date'),
          start: moment().format('MMM DD, YYYY'),
          end: moment().add(14, 'days').format('MMM DD, YYYY'),
        },
      ],
      smallLoading: false,
      accessToTabsStatus: {
        general: false,
        rentals: false,
        reviews: false,
        environment: false,
        market: false,
      },
      groups: [],
      others: [],
      mainCompetitorUrls: [],
      mainOwnRentalUrl: {},
      maxGuestCount: 20,
      maxMinNight: 30,
      defaultMinNight: 1,
      defaultGuestCount: 2,
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    DatePicker,
    colorpicker: Colorpicker,
    VLoading: require('components/loading/loading.vue'),
    VExportAnalysis: require('components/export-analysis/export-analysis.vue'),
    VGenerateConcierge: require('components/generate-concierge/Concierge'),
    VGenerateAnalyses: require('components/generate-analyses/index.vue'),
    VGenerateExtractor: require('components/generate-extractor/index.vue'),
    VGenerateCityTaxes: require('components/city-taxes/CityTaxesModal.vue'),
  },
  mixins: [mixin],
  watch: {
    async marketDate(newData) {
          // get new data for table and chart
      this.getTableDates();
      await this.get_rental_market_data(this.selectedRental);
      if (moment(newData[1]).diff(moment(newData[0]), 'days') > 60) {
        this.chartMarket.options.scales.xAxes[0].display = false;
      } else {
        this.chartMarket.options.scales.xAxes[0].display = true;
      }
      this.chartMarket.update();

      Vue.router.push({
        name: 'analytics.market.tab',
        params: {
          id: this.selectedRental,
          start: moment(newData[0]).format('YYYY-MM-DD'),
          end: moment(newData[1]).format('YYYY-MM-DD'),
        },
      });
    },
    pricesData(newData, oldData) {
      const vm = this;
      vm.pricesData = newData;
    },
  },
  methods: {
    new_rental() {
      Vue.router.push({
        name: 'rentals.create',
      });
    },
    change_tab(tab) {
      const vm = this;
      Vue.router.push({
        name: `analytics.${tab}.tab`,
        params: tab !== 'general' && { id: vm.selectedRental },
      });
    },
    async get_rental_market_data(id) {
      this.loading = true;

      if (id == 'all') {
        this.selectedRental = this.rentals[0].id;
        id = this.selectedRental;
      }

      Vue.router.push({
        name: 'analytics.market.tab',
        params: {
          id,
        },
      });
      const start = moment(this.marketDate[0]).format('YYYY-MM-DD');
      const end = moment(this.marketDate[1]).format('YYYY-MM-DD');

      const url = `/get-data-for-market/${id}?start=${start}&end=${end}`;
      await analyticsService.getMarketTab(url, this);
    },
    renderMarketChart(data) {
      const vm = this;
      vm.ctx = document.getElementById('market-chart').getContext('2d');
      vm.chartMarket = new Chart(vm.ctx, {
        type: 'line',
        data: vm.generateDataForChart(data),
        options: {
          tooltips: {
            position: 'nearest',
            mode: 'point',
            intersect: false,
            yPadding: 15,
            xPadding: 15,
            caretSize: 8,
            backgroundColor: '#fff',
            titleFontColor: '#000000',
            bodyFontColor: '#000000',
            borderColor: 'rgba(0,0,0,1)',
            borderWidth: 4,
          },
          hover: {
            mode: 'nearest',
            intersect: true,
          },
          scales: {
            xAxes: [{
              ticks: {
                fontColor: '#a2acb4',
              },
              scaleLabel: {
                display: true,
              },
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontColor: '#a2acb4',
                padding: 10,

              },
              scaleLabel: {
                display: true,
              },
            }],
          },
          maintainAspectRatio: false,
        },
      });
    },
    updateChartData(chart, data) {
      const vm = this;
      const doughnutData = vm.generateDataForChart(data);
      chart.data.labels = doughnutData.labels;
      chart.data.datasets = doughnutData.datasets;
      chart.update();
    },
    generateDataForChart(data) {
      const vm = this;

      const gradients = [];
      const datasets = [];
      let labels = [];

      if (data.own.length > 0) {
        const gcolor = vm.ctx.createLinearGradient(0, 0, 0, 600);
        gcolor.addColorStop(0, `${data.own[0].color}3b`); // "#fe763a3b"
        gcolor.addColorStop(0.5, '#ffffff00');
        gcolor.addColorStop(1, '#ffffff00');
        gradients.push(gcolor);
        labels = data.own[0].chartDates;
        const obj = {
          label: data.own[0].name,
          data: vm.replacesZerosToAvailablePrice(data.own[0].chartPrices),
          backgroundColor: gcolor,
          borderColor: data.own[0].color,
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          pointBackgroundColor: data.own[0].color,
        };

        datasets.push(obj);
      }
      if (data.competitors.length > 0) {
        for (let i = 0; i < data.competitors.length; i++) {
          const gcolor = vm.ctx.createLinearGradient(0, 0, 0, 600);
          gcolor.addColorStop(0, `${data.competitors[i].color}3b`); // "#fe763a3b"
          gcolor.addColorStop(0.5, '#ffffff00');
          gcolor.addColorStop(1, '#ffffff00');
          gradients.push(gcolor);
          labels = data.competitors[i].chartDates;
          const obj = {
            label: (data.competitors[i].name ? data.competitors[i].name : vm.$t('analytics.index.market_tab.loading')),
            data: vm.replacesZerosToAvailablePrice(data.competitors[i].chartPrices),
            backgroundColor: gcolor,
            borderColor: data.competitors[i].color,
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            pointBackgroundColor: data.competitors[i].color,
          };
          datasets.push(obj);
        }
      }

      const doughnutData = {
        labels,
        datasets,
      };

      return doughnutData;
    },
    nextDay() {
      const vm = this;
      const today = moment();
      const startDate = vm.marketDate[0];
      const endDate = vm.marketDate[1];
      const date1 = moment(startDate, 'MMM DD, YYYY').add(14, 'days');
      const date2 = moment(endDate, 'MMM DD, YYYY').add(14, 'days');

      const newStartDate = date1.format('MMM DD, YYYY');
      const newEndDate = date2.format('MMM DD, YYYY');

      if (today.diff(date1, 'days') <= 0 && date2.diff(today, 'days') <= 90) {
        vm.marketDate = [newStartDate, newEndDate];
      }
      return false;
    },
    prevDay() {
      const vm = this;
      const today = moment();
      const startDate = vm.marketDate[0];
      const endDate = vm.marketDate[1];
      const date1 = moment(startDate, 'MMM DD, YYYY').subtract(14, 'days');
      const date2 = moment(endDate, 'MMM DD, YYYY').subtract(14, 'days');

      const newStartDate = date1.format('MMM DD, YYYY');
      const newEndDate = date2.format('MMM DD, YYYY');

      if (today.diff(date1, 'days') <= 0 && today.diff(date2, 'days') >= -90) {
        vm.marketDate = [newStartDate, newEndDate];
      }
      return false;
    },
    async saveOwnRentalUrl() {
      this.disabled = true;
      this.smallLoading = true;
      await rentalService.addOrUpdateOwnUrl(this.selectedRental, this.ownRentalUrl, this);
    },
    async saveCompetitorsRentalsUrls() {
      this.disabled = true;
      this.smallLoading = true;
      await rentalService.addOrUpdateCompetitorsUrls(this.selectedRental, this.competitorsUrls, this);
      mixpanel.track('web.analytics.concurrent.add');
    },
    addNewUrlToCompetitorsObj() {
      this.competitorsUrls.push({
        id: null,
        url: '',
        name: '',
        color: this.getRandomColor(),
      });
    },
    async removeUrlFromCompetitors(competitor, index) {
      const vm = this;
      if (vm.competitorsUrls.length == 0) {
        return false;
      }
      vm.disabled = true;
      if (competitor.id) {
        vm.closeModal('#competitors-rental-modal');
        swal({
          title: this.$t('account.settings.are_you_sure'),
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div><br></div>',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: this.$t('account.settings.not_now'),
          confirmButtonClass: 'btn-success',
          confirmButtonText: this.$t('button.yes'),
          closeOnConfirm: true,
          html: true,
        },
              async (isConfirm) => {
                if (isConfirm) {
                  vm.loading = true;
                  await rentalService.deleteCompetitorUrl(competitor.id, index, vm);
                } else {
                  vm.disabled = false;
                  vm.loading = false;
                  vm.openModal('#competitors-rental-modal');
                }
              });
      } else {
        vm.competitorsUrls.splice(index, 1);
        if (vm.competitorsUrls.length == 0) {
          vm.addNewUrlToCompetitorsObj();
        }
      }

      vm.disabled = false;
    },
    getMarketDataForPeriod() {
      this.pricesData = {
        own: [],
        competitors: [],
      };

      const keys = Object.keys(this.prices);

      if (keys.length > 0 && this.prices.own_property.length > 0) {
        const own_property = this.prices.own_property[0];
        this.pricesData.own.push(this.collectMarketDataForCurrentPeriod(own_property));
      }
      if (keys.length > 0 && this.prices.competitors.length > 0) {
        this.prices.competitors.map((competitor) => {
          this.pricesData.competitors.push(this.collectMarketDataForCurrentPeriod(competitor));
        });
      }
    },
    collectMarketDataForCurrentPeriod(prop) {
      const rental = this.rentals.find(obj => obj.id === this.selectedRental);

      const data = {
        prices: prop.prices,
        chartPrices: [],
        chartDates: [],
        color: ((prop.color === '' || prop.color == null) ? this.getRandomColor() : prop.color),
        name: (prop.name === '' ? rental.name : prop.name),
      };

      this.tableDates.map((date) => {
        const price = prop.prices.find(propPrice => moment(propPrice.date).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD'));
        const chartPrice = price ? price.value : 0;
        data.chartPrices = [
          ...data.chartPrices,
          chartPrice,
        ];
        const chartDate = moment(date).format('DD MMM');
        data.chartDates = [
          ...data.chartDates,
          chartDate,
        ];
      });
      return data;
    },
    getRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    replacesZerosToAvailablePrice(data) {
      let last_value = null;
      const len = data.length;

      for (let i = 0; i < len; i++) {
        if (data[i] > 0) {
          last_value = data[i];
        } else {
          data[i] = last_value;
        }

        if (last_value > 0 && data[0] == null) {
          for (let j = i; j >= 0; j--) {
            data[j] = last_value;
          }
        }
      }
      return data;
    },
    getOtherRentals() { // get rentals which are not in any groups
      const vm = this;
      const removed = [];
      const isGroups = vm.groups.length > 0;
      // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: 'others',
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      for (let i = 0; i < vm.rentals.length; i++) {
        const rental = vm.rentals[i];
        for (let j = 0; j < vm.groups.length; j++) {
          const group = vm.groups[j];
          const check = group.rentals.filter(r => r.id === rental.id);
          if (check.length > 0) {
            const check1 = vm.others.filter(r => r.id === rental.id);
            if (check1.length > 0) {
              const index = vm.others.indexOf(rental);
              vm.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = vm.others.filter(r => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              vm.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups) {
        const group = {
          id: 0,
          name: 'others',
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      return vm.others;
    },
    openCompetitorModal() {
      this.competitorsUrls = [];
      this.mainCompetitorUrls.map(
        compUrl => this.competitorsUrls = [
          ...this.competitorsUrls,
          { ...compUrl },
        ],
      );
      this.openModal('#competitors-rental-modal');
    },
    openOwnRentalUrlModal() {
      this.ownRentalUrl = {};
      this.ownRentalUrl = { ...this.mainOwnRentalUrl };
      this.openModal('#own-rental-modal');
    },
    getDate(date) {
      return moment(date).format('ddd DD MMM');
    },
    getPriceValue(prices, date) {
      const datePrice = prices.find(price => moment(price.date).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD'));

      return datePrice ? datePrice.value : 'N/A';
    },
    getTableDates() {
      let startDate = moment(this.marketDate[0]);
      const endDate = moment(this.marketDate[1]);
      this.tableDates = [];
      while (startDate <= endDate) {
        this.tableDates.push(startDate.format('YYYY-MM-DD'));
        startDate = startDate.add(1, 'days');
      }
    },
    getMinOrMaxClass(date, prices) {
      const currentDate = moment(date).format('YYYY-MM-DD');

      const maxPrice = prices.find((pr) => {
        const prDate = moment(pr.date).format('YYYY-MM-DD');

        return currentDate === prDate && pr.value === this.max[currentDate];
      });

      if (maxPrice) {
        return 'price price-down';
      }

      const minPrice = prices.find((pr) => {
        const prDate = moment(pr.date).format('YYYY-MM-DD');

        return currentDate === prDate && pr.value === this.min[moment(date).format('YYYY-MM-DD')];
      });

      if (minPrice) {
        return 'price price-up';
      }

      return 'price';
    },
  },
  async mounted() {
    const vm = this;
    vm.loading = true;
    vm.dontRemoveLoading = true;
    await accountService.fetchUserAccount(vm);
    await this.checkAccessToTabs(this);
    await rentalService.getAll(this, true);
    await rentalService.getGroups(this, false, true);
    if (vm.$route.params.id && vm.$route.params.start && vm.$route.params.end) {
      vm.selectedRental = vm.$route.params.id;
      this.marketDate = [
        moment(vm.$route.params.start, 'Y-MM-DD').format('YYYY-MM-DD'),
        moment(vm.$route.params.end, 'Y-MM-DD').format('YYYY-MM-DD'),
      ];
    } else {
      if (vm.rentals.length > 0) {
        vm.selectedRental = vm.rentals[0].id;
      } else {
        vm.selectedRental = '';
      }

      Vue.router.push({
        name: 'analytics.market.tab',
        params: {
          id: vm.selectedRental,
          start: moment(vm.marketDate[0], 'MMM DD, YYYY').format('YYYY-MM-DD'),
          end: moment(vm.marketDate[1], 'MMM DD, YYYY').format('YYYY-MM-DD'),
        },
      });
    }
    this.getOtherRentals();
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/analytics/market/market.js